<script>
import VueDocPreview from "vue-doc-preview";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PageAlerts from "@/components/page-alerts";
import appConfig from "@/app.config";
import { mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Report View",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    VueDocPreview,
    Layout,
    PageHeader,
    PageAlerts,
  },
  data() {
    return {
      title: "View Reports",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Reports Filter",
          href: "/reports/filter",
        },
        {
          text: "Reports View",
          active: true,
        },
      ],
      data: {},
    };
  },
  watch: {},
  computed: {
    ...mapGetters("marks", [
      "getYears",
      "getReportDetails",
      "getFechingReports",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  mounted() {},
  methods: {},
  created() {},
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('report_cards')
        )
      "
    >
      <div class="row d-flex">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <VueDocPreview
                  v-if="getReportDetails && getReportDetails.report_url"
                  :value="getReportDetails.report_url + '.docx'"
                  type="office"
                />
                <div class="col-lg-12" v-else>
                  <PageAlerts
                    title="No Report"
                    primaryMsg="No report data found"
                    alertType="secondary"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- end card -->
        </div>
      </div>
    </div>
    <!-- <div class="breaker"></div> -->
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.bod {
  border: 1px solid gray;
}
.break {
  page-break-after: auto !important;
  page-break-before: always;
}
</style>
